// extracted by mini-css-extract-plugin
export var alignCenter = "_9x-d";
export var bannerShown = "_9x-6";
export var buttonContent = "_9x-0";
export var cardList = "_9x-1";
export var centerContent = "_9x-2";
export var chevron = "_9x-3";
export var closePanelButton = "_9x-k";
export var conversationContextContainer = "_9x-l";
export var conversationDetailContainer = "_9x-4";
export var detailWrapper = "_9x-7";
export var dropdownButton = "_9x-e";
export var dropdownTitle = "_9x-9";
export var fullHeight = "_9x-5";
export var hidden = "_9x-a";
export var icon = "_9x-b";
export var mergeSuggestionWrapper = "_9x-m";
export var panel = "_9x-i";
export var portalButtonsWrapper = "_9x-c";
export var right = "_9x-j";
export var tableSummaryContainer = "_9x-8";
export var tableSummaryHeader = "_9x-g";
export var threeDotsButton = "_9x-f";
export var wide = "_9x-h";